import { useState, useEffect } from "react";
import { BreakpointSize } from "types";

export const useBreakpoint = (
  breakpoint: BreakpointSize = BreakpointSize.m
) => {
  const breakpointMatches = () =>
    window.matchMedia(`(max-width: ${breakpoint}px)`).matches;

  const [matches, setMatches] = useState(breakpointMatches());

  useEffect(() => {
    const updateMatches = () => {
      setMatches(breakpointMatches());
    };

    window.addEventListener("resize", updateMatches);

    // remove listener on unmount
    return () => {
      window.removeEventListener("resize", updateMatches);
    };
  });

  return { matches };
};
